export default __webpack_public_path__ + "static/media/logo.c1b0f3bc.png";